export const ACTIONS = {
  SET_CURRENT_SHEET_LOCATION: 'SET_CURRENT_SHEET_LOCATION',
  SET_NAVIGATION_BAR_STATE: 'SET_NAVIGATION_BAR_STATE',
  SET_PERFECT_HIT: 'SET_PERFECT_HIT',
};

export const setCurrentSheetLocation = data => ({
  type: ACTIONS.SET_CURRENT_SHEET_LOCATION,
  payload: {
    ...data,
  },
});

export const setNavigationBarState = data => ({
  type: ACTIONS.SET_NAVIGATION_BAR_STATE,
  payload: {
    ...data,
  },
});

export const setPerfectHit = data => ({
  type: ACTIONS.SET_PERFECT_HIT,
  payload: {
    ...data,
  },
});
